<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="600px"
    scrollable

  >
    <v-card
      height="500px"
    >
      <v-text-field
        v-model="term"
        :label="$t('Search customers by last name')"
        class="search-field"
        prepend-inner-icon="search"
        solo
        dark
        single-line
        background-color="primary"
        color="white"
        clearable
        @input="handleSearch"
      />

      <v-card-text
        style="height:450px"
      >

        <v-list
          two-line
          subheader
          dense
        >
          <template
            v-for="item in customers"
          >
            <v-divider
              :key="`d-${item.id}`"
            />
            <v-list-tile

              :key="item.id"
              avatar
              @click="select(item)"
            >
              <v-list-tile-avatar color="primary">
                <v-icon color="white">
                  perm_identity
                </v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>
                  {{ item.firstname }} {{ item.lastname }}
                </v-list-tile-title>
                <v-list-tile-sub-title>{{ item.email }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>

        </v-list>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          color="primary"
          flat
          small
          @click="cancel"
        >
          {{ $t('Cancel') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import debounce from 'lodash.debounce'

export default {
  name: 'SearchCustomer',

  data () {
    return {
      dialog: false,
      term: '',
      customers: [],
      resolve: null,
      reject: null
    }
  },

  created () {
    this.handleSearch = debounce(this.search, 700)
  },

  async mounted () {
    this.customers = await this.$http.customer.orderBy('-created_at').get()
  },

  methods: {
    find () {
      this.resolve = null
      this.reject = null
      this.dialog = true
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },

    select (item) {
      this.resolve(item)
      this.dialog = false
    },

    cancel () {
      this.resolve(false)
      this.dialog = false
      this.$router.push({ name: 'quotes' })
    },

    async search (term) {
      if (!term) {
        return
      }
      this.customers = await this.$http.customer
        .where('lastname', 'like', term)
        .orderBy('-created_at')
        .get()
    }
  }
}
</script>
